import type { WebAppStage } from "@/src/@types/env";
import type { EnvironmentClient } from "@iot-platform/core";
import { injectable } from "inversify";

@injectable()
export class ViteEnvironmentClient implements EnvironmentClient {
    // API
    get apiServerUrl(): string {
        return import.meta.env.VITE_IOT_ADMIN_API_SERVER_URL;
    }

    get apiBaseUrl(): string {
        return import.meta.env.VITE_IOT_ADMIN_API_BASE_URL;
    }

    // Links
    get privacyUrl(): string {
        return import.meta.env.VITE_IOT_ADMIN_PRIVACY_URL;
    }

    // Web
    get appStage(): WebAppStage {
        return import.meta.env.VITE_IOT_APP_STAGE;
    }

    get appTitle(): string {
        return import.meta.env.VITE_IOT_APP_TITLE;
    }

    get gtmId(): string {
        return import.meta.env.VITE_GTM_ID;
    }

    get mockApiEnabled(): boolean {
        return import.meta.env.VITE_IOT_ADMIN_MOCK_API === "true";
    }

    get mockUrl(): string {
        return import.meta.env.VITE_MOCK_URL;
    }

    get isDevelopment(): boolean {
        return this.appStage === "development";
    }

    get isProduction(): boolean {
        return this.appStage === "production";
    }
}
